import { request } from ".";

// 视频、脚本 收藏列表查询
const fetchCollectionList = async <T>({ type }: any) => {
  return request<T>({
    method: "post",
    url: "/api/users/collection/queryList",
    data: { type },
  });
};

// 视频、脚本 收藏删除
const fetchDeleteCollection = async <Table>(reqData: unknown) => {
  return request<Table>({
    method: "get",
    url: "/api/users/collection/delete",
    params: reqData,
  });
};

/**
 * 收藏视频或收藏脚本
 * @param {type} 1、视频；2、视频脚本
 * @param {keyword} 类型为1使用视频id;类型为2使用任务id
 * @param {params}
 * @returns
 */
const fetchSaveScriptOrVideo = async <T>({ type, keyword, params }: any) => {
  return request<T>({
    method: "post",
    url: "/api/users/collection/save",
    data: {
      type,
      keyword,
      params,
    },
  });
};

// 收藏详情查询
const fetchCollectionDetail = async <Table>({ collectionId }: any) => {
  return request<Table>({
    method: "get",
    url: "/api/users/collection/queryDetail",
    params: { collectionId },
  });
};

// 查询资产列表（收藏夹）
const fetchAssets = async <T>(data: { assetType: "IMG" | "VIDEO"; pageNo?: number; pageSize?: number }) => {
  return request<T>({
    method: "get",
    url: `/api/users/assets`,
    params: data,
  });
};

// 商品取消关注
const cancelEntity = async (data: any) => {
  return request({
    method: "post",
    url: "/api/focus/cancelEntity",
    data,
  }).then((res) => {
    return res;
  });
};

// 查询回收站列表
const fetchTrash = async <T>(id: string) => {
  return request<T>({
    method: "post",
    url: `/api/users/trash`,
    data: { id },
  });
};

// 查询回收站列表
const fetchTrashList = async <T>() => {
  return request<T>({
    method: "get",
    url: `/api/users/trash`,
  });
};

// 清空回收站
const emptyTrash = async <T>() => {
  return request<T>({
    method: "delete",
    url: `/api/users/trash/empty`,
  });
};

// 从回收站恢复
const restoreFromTrash = async <T>(id: string) => {
  return request<T>({
    method: "post",
    url: `/api/users/trash/restore`,
    data: { id },
  });
};

// 从回收站永久删除
const deleteFromTrash = async <T>(id: string) => {
  return request<T>({
    method: "delete",
    url: `/api/users/trash`,
    data: { id },
  });
};

// AI 任务重试（重新提交）
const resubmitAiJob = async <T>(data: { id: string; internalModelId: string }) => {
  return request<T>({
    method: "post",
    url: "/api/users/ai-jobs/resubmit",
    data,
  });
};

// 查询问题报告退款次数配额
const fetchRefundQuota = async () => {
  return request<{ jobType: string; remaining: number; total: number }>({
    method: "get",
    url: "/api/report/refund-quota",
    params: { jobType: "VIDEO_CREATION" },
  });
};

// 查询资产是否已下载
const fetchAssetDownloaded = async (assetId: number) => {
  return request<boolean>({
    method: "get",
    url: "/api/asset/downloaded",
    params: { assetId },
  });
};

// 获取资产状态（code: 1=正常, 0=回收站, -1=已删除, -2=已退还）
const fetchAssetState = async (assetId: number) => {
  return request<{ code: number; description: string }>({
    method: "get",
    url: "/api/asset/state",
    params: { assetId },
  });
};

// 下载视频上报
const downloadReport = async (data: { assetId: number }) => {
  return request({
    method: "post",
    url: "/api/asset/record-download",
    data,
  });
};

// 提交问题报告
const submitReport = async (data: {
  jobType: string;
  assetId: number;
  feedback: { issueTypes: string[]; otherDescription?: string };
}) => {
  return request({
    method: "post",
    url: "/api/report/submit",
    data,
  });
};

export default {
  fetchDeleteCollection,
  fetchCollectionList,
  fetchSaveScriptOrVideo,
  fetchCollectionDetail,
  fetchAssets,
  fetchTrashList,
  emptyTrash,
  restoreFromTrash,
  deleteFromTrash,
  cancelEntity,
  fetchTrash,
  resubmitAiJob,
  fetchRefundQuota,
  fetchAssetDownloaded,
  fetchAssetState,
  submitReport,
  downloadReport,
};
